import { Repository } from './repository';

/**
 * @async
 * @callback DateRangeRepository~dateRangeGetter
 * @param {object} options - SEE BELOW
 * @param {string} options.namespace - The namespace to get the date range from
 * @returns {Promise<DateRange>} A promise of the current date range for the Applet Host in the shape of https://github.com/meltwater/date-range
 */

/**
 * @callback DateRangeRepository~dateRangeSetter
 *
 * @param {DateRange} dateRange - The date range to update to in the shape of https://github.com/meltwater/date-range
 * @param {string} namespace - The namespace to set the date range for
 * @throws {TypeError} the provided dateRange is not coercable to DateRange
 * @throws {Error} - An unknown error or an error specific an applet host implementation
 * @returns {undefined}
 */

/**
 * @param {object} options - SEE BELOW
 * @param {DateRangeRepository~dateRangeGetter} options.get - Function to get the current date range in the shape of https://github.com/meltwater/date-range
 * @param {DateRangeRepository~dateRangeSetter} [options.set] - Function to set the current date range in the shape of https://github.com/meltwater/date-range
 */
export class DateRangeRepository extends Repository {}
